import { MessengerStages } from '../../models/Messenger';
import { createSlice } from '../wrappers';

interface IMessengerState {
	activeMessengerState: MessengerStages;
}

const initialState: IMessengerState = {
	activeMessengerState: MessengerStages.DIALOGS,
};

const messengerSlice = createSlice({
	name: 'messenger',
	initialState,
	reducers: {
		setActiveMessengerState: (state, action) => {
			state.activeMessengerState = action.payload;
		},
	},
});

export const { setActiveMessengerState } = messengerSlice.actions;

export default messengerSlice.reducer;
